






































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SelectFieldHeader extends Vue {
  private fieldSort (name: string) {
    this.$emit('field-sort', name)
  }
}
